'use strict';

import Loading from '../components/Loading';

const RequestComment = React.lazy(() => import( /* webpackChunkName: "RequestComment" */ '../components/RequestComment'));
const RequestFacilities = React.lazy(() => import( /* webpackChunkName: "RequestFacilities" */ '../components/RequestFacilities'));
const RequestPlaneCheckList = React.lazy(() => import( /* webpackChunkName: "RequestPlaneCheckList" */ '../components/RequestPlaneCheckList'));
const RequestSeatsForm = React.lazy(() => import( /* webpackChunkName: "RequestSeatsForm" */ '../components/RequestSeatsForm'));
const SearchRequestFooter = React.lazy(() => import( /* webpackChunkName: "SearchRequestFooter" */ '../components/SearchRequestFooter'));

export default class SearchRequest extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            comment: '',
            selectedClasses: [0],
            selectedAdditional: [],
        }
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    getTotalPrice() {
        const {prices} = this.props;
        const {seats, seatsSofa, sofa} = this.state;
        let price = 0;
        if(prices.seat && seats) price += prices.seat * seats;
        if(prices.seatSofa && seatsSofa) price += prices.seatSofa * seatsSofa;
        if(prices.sofa && sofa) price += prices.sofa;
        return price;
    }

    handleSubmit() {
        const {type, routes} = this.props;
        const {seats, seatsSofa, sofa, selectedClasses, selectedAdditional, comment} = this.state;

        if(!checkAuth()) return;

        this.setState({isFetching: true});
        requestAction.submitRequest({type, routes, seats, seatsSofa, sofa, selectedClasses, selectedAdditional, comment}).then(response => {
            this.setState({
                isFetching: false,
                errors: response.errors,
            })
            if(response.status === 'success') {
                successPopup(type);
                $('body, html').animate({scrollTop: 0}, 500);
                raiseEvent('toggleSideBeard', {state: {type: 'requests', tab: 'current', filter: 'all'}});

                ymReachGoal('search_request')
            }
        });
    }

    render() {
        const {type, classes, additional, routes, prices} = this.props;
        const {isFetching, seats, seatsSofa, sofa, selectedClasses, selectedAdditional, comment} = this.state;

        return <div className={clsx(type === 'planes' ? 'request-form' : 'flight-app')}>
            <React.Suspense fallback={<Loading active={true} />}>
                {type === 'planes' && <RequestPlaneCheckList
                        classes={classes}
                        additional={additional}
                        selectedClasses={selectedClasses}
                        selectedAdditional={selectedAdditional}
                        onChange={selected => this.setState(selected)}
                    /> }

                {type === 'planes' && <RequestComment
                    commment={comment}
                    onChange={comment => this.setState({comment})}
                />}

                {type === 'seats' && <RequestSeatsForm
                    seats={{seats, seatsSofa, sofa}}
                    prices={prices}
                    showPrice={true}
                    onChange={seats => this.setState(seats)}
                />}

                {type === 'seats' && <RequestFacilities isSeats={true}/>}
                
                <SearchRequestFooter
                    type={type}
                    routes={routes}
                    price={this.getTotalPrice().formatPrice()}
                    showPrice={type === 'seats'}
                    onSubmit={this.handleSubmit}
                />

                <Loading active={isFetching}/>
            </React.Suspense>
        </div>
    }
}
